export function parseDate(dateStr?: string): number {
  if (!dateStr) return 0;
  const cleaned = dateStr.replace(',', '');
  return new Date(cleaned).getTime();
}
